// src/api.jsx

import axios from "axios";

//  for your API
const BASE_URL = process.env.REACT_APP_API_BASEURL;

// GET request function
export const getData = async (endpoint) => {
  const token = localStorage.getItem("token"); // Fetch the token from local storage
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Error fetching data: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};
export const updateData = async (url, data) => {
  try {
    const response = await fetch(url, {
      method: "PUT", // Assuming it's a POST request, change it if it's PUT or PATCH
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  } catch (error) {
    console.error("Error updating data", error);
    throw error;
  }
};

// POST request function
export const postData = async (endpoint, data) => {
  const token = localStorage.getItem("token"); // Fetch the token from local storage
  // try {
  const response = await fetch(`${BASE_URL}${endpoint}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });

  // if (!response.ok) {
  //   throw new Error(`Error posting datagggh: ${response.json()}`);
  // }

  const responseData = await response.json();
  console.log("errerNew", responseData);
  return responseData;

  // } catch (error) {
  //   console.error('Error posting datavvv:', error.status);
  //   throw error;
  // }
};

export const putData = async (endpoint, data) => {
  const token = localStorage.getItem("token"); // Fetch the token from local storage
  // try {
  const response = await fetch(`${BASE_URL}${endpoint}`, {
    method: "Put",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });

  // if (!response.ok) {
  //   throw new Error(`Error posting datagggh: ${response.json()}`);
  // }

  const responseData = await response.json();
  console.log("errerNew", responseData);
  return responseData;

  // } catch (error) {
  //   console.error('Error posting datavvv:', error.status);
  //   throw error;
  // }
};

export const FilePutData = async (endpoint, data) => {
  const token = localStorage.getItem("token"); // Fetch the token from local storage
  // try {
  const response = await fetch(`${BASE_URL}${endpoint}`, {
    method: "Put",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });

  // if (!response.ok) {
  //   throw new Error(`Error posting datagggh: ${response.json()}`);
  // }

  const responseData = await response.json();
  console.log("errerNew", responseData);
  return responseData;

  // } catch (error) {
  //   console.error('Error posting datavvv:', error.status);
  //   throw error;
  // }
};
export const FilePostData = async (endpoint, data) => {
  const token = localStorage.getItem("token");

  const formData = new FormData();
  for (const key in data) {
    formData.append(key, data[key]);
  }

  const response = await fetch(`${BASE_URL}${endpoint}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`, // Don't manually set Content-Type
    },
    body: formData,
  });

  const responseData = await response.json();
  return responseData;
};

export const FileGetData = async (endpoint) => {
  const token = localStorage.getItem("token");

  const response = await fetch(`${BASE_URL}${endpoint}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "text/csv",
    },
  });

  return response;
};

export const Delete = async (endpoint, params) => {
  console.log("endpoint",endpoint)
  const token = localStorage.getItem("token");

  try {
    const response = await axios.delete(`${BASE_URL}${endpoint}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: params, // 👈 query parameters like ?id=123
    });

    console.log("responseData", response.data);
    return response.data;
  } catch (error) {
    console.error("Error deleting data:", error.response?.data || error.message);
    return { error: true, message: error.response?.data || error.message };
  }
};

